import React from 'react';
import {useNavigate} from 'react-router-dom';
import * as Fa6Icons from 'react-icons/fa6';
import GameBackground from '../components/game/GameBackground';
import Footer from '../components/common/Footer';
import Button from '../components/common/Button';
import ContentDates from '../components/common/ContentDates';
import SafeIcon from '../components/common/SafeIcon';
import SEOHead from '../components/SEO/SEOHead';

const {
  FaFacebook,
  FaInstagram,
  FaThreads,
  FaGlobe
} = Fa6Icons;

const About = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEOHead
        title="關於我們 - 泡泡樂園"
        description="認識泡泡樂園背後的開發團隊 Homy Tech Limited，了解我們製作免費休閒遊戲的理念，並可透過官網或社交媒體與我們聯繫、提供意見或洽談合作。"
        canonical="https://bubble.homy.hk/#/about"
      />
      <GameBackground />
      <div className="min-h-screen flex flex-col">
        <main className="flex-1 flex flex-col items-center justify-center p-6">
          <article
            className="max-w-2xl w-full bg-white/90 backdrop-blur-sm rounded-3xl p-6 sm:p-8 shadow-xl"
            itemScope
            itemType="https://schema.org/AboutPage"
          >
            <header className="mb-8 text-center">
              <h1
                className="text-3xl sm:text-4xl font-bold mb-3 bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent"
                itemProp="name headline"
              >
                關於泡泡樂園
              </h1>
              <ContentDates
                published="2024-01-01"
                updated="2024-01-20"
                className="text-center"
              />
            </header>

            <section className="mb-8">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-3">
                泡泡樂園是由誰開發與營運的?
              </h2>
              <p className="text-gray-700 leading-relaxed">
                泡泡樂園由{' '}
                <strong className="text-pink-600">
                  Homy Tech Limited
                </strong>{' '}
                開發與營運。我們專注於製作輕鬆好玩、老少咸宜的免費網頁小遊戲，希望每個人都能隨時隨地打開瀏覽器，就能享受幾分鐘的放鬆與樂趣，無需下載、無需註冊。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-3">
                為甚麼要創作泡泡樂園?
              </h2>
              <p className="text-gray-700 leading-relaxed">
                我們相信最好的休閒遊戲應該簡單易懂，卻又充滿深度。泡泡樂園結合連擊系統、成就收集與多種遊戲模式，讓玩家可以不斷挑戰自己的最高分，同時保持輕鬆愉快的遊玩體驗。
              </p>
            </section>

            <section>
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">
                如何聯絡泡泡樂園開發團隊?
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                有任何問題、建議或合作邀約，歡迎透過以下方式與 Homy Tech Limited 聯繫：
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="https://homy.hk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2 bg-pink-100 hover:bg-pink-200 text-pink-700 rounded-full font-bold transition-colors"
                >
                  <SafeIcon icon={FaGlobe} aria-hidden="true" />
                  官方網站
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61578745554661"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-full font-bold transition-colors"
                >
                  <SafeIcon icon={FaFacebook} aria-hidden="true" />
                  Facebook
                </a>
                <a
                  href="https://www.instagram.com/homy.hk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2 bg-purple-100 hover:bg-purple-200 text-purple-700 rounded-full font-bold transition-colors"
                >
                  <SafeIcon icon={FaInstagram} aria-hidden="true" />
                  Instagram
                </a>
                <a
                  href="https://www.threads.com/@homy.hk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-full font-bold transition-colors"
                >
                  <SafeIcon icon={FaThreads} aria-hidden="true" />
                  Threads
                </a>
              </div>
            </section>

            <div className="mt-8 text-center">
              <Button onClick={() => navigate('/')} variant="secondary">
                🏠 回到首頁
              </Button>
            </div>
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default About;